export default __webpack_public_path__ + "static/media/activatedLight.b9f589f4.svg";